'use client';
import { rem } from '../../../modules/sizes/impl/units/units.js';

var cover = function(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: "absolute",
        top: rem(offset),
        right: rem(offset),
        left: rem(offset),
        bottom: rem(offset)
    };
};

export { cover };
